import api from './api';
import { getCurrentUser } from '../helpers/Utils';

// O backend SEMPRE devolve horários absolutos em UTC (nunca converte na
// origem - ver comentário em InstallationSettings no indominus-admin). O
// fuso pra exibir é uma configuração da instalação, não uma constante de
// código: o Brasil tem 4 fusos (Noronha, Brasília, Amazonas/Mato Grosso,
// Acre) e cada cliente/estado que contrata o sistema pode estar em um
// diferente. Este módulo busca essa config e cacheia em memória só o SUCESSO
// (não muda durante a sessão do usuário, não faz sentido buscar de novo a
// cada render de cada componente que formata um horário).
const DEFAULT_TIMEZONE = 'America/Sao_Paulo';

// Cache de 1 entrada, atrelado ao token da sessão (F-15): outro usuário/logout
// não reaproveita o fuso da sessão anterior e uma falha NUNCA fica cacheada -
// a próxima chamada tenta de novo.
let cache = null;

export const resetInstallationSettingsCache = () => {
  cache = null;
};

export const getInstallationTimezone = () => {
  const user = getCurrentUser();
  const token = user && user.token;
  // Sem sessão não há o que buscar (e nada deve ser cacheado).
  if (!token) return Promise.resolve(DEFAULT_TIMEZONE);
  if (cache && cache.token === token) return cache.promise;

  const entry = { token, promise: null };
  entry.promise = api
    .get('/installation-settings/')
    .then(
      (response) =>
        (response.data && response.data.timezone) || DEFAULT_TIMEZONE
    )
    .catch(() => {
      if (cache === entry) cache = null;
      return DEFAULT_TIMEZONE;
    });
  cache = entry;
  return entry.promise;
};

export const TIMEZONE_LABELS = {
  'America/Noronha': 'horário de Fernando de Noronha',
  'America/Sao_Paulo': 'horário de Brasília',
  'America/Manaus': 'horário do Amazonas/Mato Grosso',
  'America/Rio_Branco': 'horário do Acre',
};

// Formata um ISO string absoluto (SEMPRE UTC com offset explicito, vindo
// do backend) na hora local da instalacao. Compartilhado entre qualquer
// componente que exiba um horario absoluto (badge de status, popup de
// trajeto, etc) - nao repete a logica de fuso em cada um.
export const formatDateTimeInTimezone = (isoString, tz, options) => {
  if (!isoString || !tz) return null;
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString('pt-BR', { timeZone: tz, ...options });
};

export const formatTimeInTimezone = (isoString, tz) =>
  formatDateTimeInTimezone(isoString, tz, {
    hour: '2-digit',
    minute: '2-digit',
  });

export default getInstallationTimezone;
